import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './lib/analytics/analytics';
import './reset.scss';

ReactDOM.render(<App />, document.getElementById('root'));
